import MegaMenuColumn from './MegaMenuColumn.jsx';
import AdditionalLink from './AdditionalLink.jsx';
import LdsIcon from '../LdsIcon/index.jsx';
export default function MegaMenu({
  additionalLink,
  itemText,
  active,
  toggleOpen,
  megaMenuItems = [],
  index: menuIndex,
  menuType,
  isMobile,
  closeMegaMenuLabel,
  controlId,
}) {
  return (
    <div
      className="lds-header-mega-menu"
      role="region"
      aria-expanded={active}
      aria-hidden={!active}
      style={{ visibility: active ? 'visible' : 'hidden' }}
      id={controlId}
    >
      <div
        id={`lds-header-mega-menu-title-${menuType}-${menuIndex}`}
        className="lds-header-mega-menu-title"
      >
        <button
          id="lds-header-mega-menu-back"
          onClick={toggleOpen}
          type="button"
          className="lds-button-base lds-header-mega-menu-back toggleHeaderMenu"
        >
          <LdsIcon
            aria-hidden={!active}
            decorative
            inline
            label={closeMegaMenuLabel}
            name="CaretLeft"
          />
        </button>
        <div
          style={{ display: 'inline-block' }}
          dangerouslySetInnerHTML={{
            __html: itemText,
          }}
        />
      </div>

      <div className="lds-header-mega-menu-container">
        <div className="lds-header-mega-menu-wrapper wrapper">
          <div className="lds-header-mega-menu-content-wrapper lds-header-mega-menu-content-wrapper-full lds-header-mega-menu-content-wrapper-menus">
            <div className="lds-header-mega-menu-container">
              <div className="lds-header-mega-menu-container-menus">
                {megaMenuItems.map(({ menuName, menuItems }, columnIndex) => (
                  <MegaMenuColumn
                    key={columnIndex}
                    menuName={menuName}
                    menuItems={menuItems}
                    columnIndex={columnIndex}
                    menuIndex={menuIndex}
                    isMobile={isMobile}
                  />
                ))}
              </div>
              <AdditionalLink {...additionalLink} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
